// extracted by mini-css-extract-plugin
module.exports = {"classInfo":"ClassInfo_classInfo__2vhJz","icon":"ClassInfo_icon__1hutI","subTitle":"ClassInfo_subTitle__1-t4i"};